export const name_validation_hr = {
  name: "name",
  label: "name",
  type: "text",
  id: "name",
  placeholder: "Vaše ime",
  multiline: false,
  className: "",
  validation: {
    required: {
      value: true,
      message: "obavezno",
    },
    maxLength: {
      value: 30,
      message: "maksimalno 30 znakova",
    },
  },
};

export const from_hidden_validation_hr = {
  name: "form",
  label: "form",
  type: "hidden",
  id: "form",
  placeholder: "",
  className: "",
  value: "Footer Form",
  validation: {
    required: {
      value: true,
      message: "obavezno",
    },
  },
};

export const to_hidden_validation_hr = {
  name: "to",
  label: "to",
  type: "hidden",
  id: "to",
  placeholder: "",
  className: "",
  value: "web@twid.marketing",
  validation: {
    required: {
      value: true,
      message: "obavezno",
    },
  },
};

export const company_validation_hr = {
  name: "company",
  label: "company",
  type: "text",
  id: "company",
  placeholder: "Tvrtka",
  multiline: false,
  className: "",
  validation: {
    required: {
      value: false,
      message: "obavezno",
    },
    maxLength: {
      value: 30,
      message: "maksimalno 30 znakova",
    },
  },
};

export const message_validation_hr = {
  name: "message",
  label: "message",
  type: "textarea",
  multiline: true,
  id: "message",
  placeholder: "Poruka",
  className: "",
  validation: {
    required: {
      value: true,
      message: "obavezno",
    },
    maxLength: {
      value: 200,
      message: "maksimalno 200 znakova",
    },
  },
};

export const password_validation_hr = {
  name: "password",
  label: "password",
  type: "password",
  id: "password",
  placeholder: "type password ...",
  validation: {
    required: {
      value: true,
      message: "obavezno",
    },
    minLength: {
      value: 6,
      message: "min 6 znakova",
    },
  },
};

export const num_validation_hr = {
  name: "num",
  label: "number",
  type: "number",
  id: "num",
  placeholder: "write a random number",
  validation: {
    required: {
      value: true,
      message: "obavezno",
    },
  },
};

export const email_validation_hr = {
  name: "email",
  label: "email address",
  type: "email",
  id: "email",
  placeholder: "E-mail",
  multiline: false,
  className: "",
  validation: {
    required: {
      value: true,
      message: "obavezno",
    },
    pattern: {
      value:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      message: "nije valjano",
    },
  },
};
